import { Component } from '@angular/core';
import { AppStateService } from '../services/appState.service';
// import {enableProdMode} from '@angular/core';

// enableProdMode()

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'
    ],
    providers: [AppStateService]
})
export class AppComponent {
    constructor(private appStateService: AppStateService) {
    }
}
